var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPcfStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.0007 60V85.0008M64.9991 85.0008V75",
    stroke: "#0D5F4F",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 74.9999L29.1504 60.8495M40.0008 34.9991C36.0226 34.9991 32.2072 36.5795 29.3942 39.3925C26.5812 42.2056 25.0008 46.0209 25.0008 49.9991C25.0008 53.9774 26.5812 57.7927 29.3942 60.6057C32.2072 63.4188 36.0226 64.9991 40.0008 64.9991C43.979 64.9991 47.7944 63.4188 50.6074 60.6057C53.4204 57.7927 55.0008 53.9774 55.0008 49.9991C55.0008 46.0209 53.4204 42.2056 50.6074 39.3925C47.7944 36.5795 43.979 34.9991 40.0008 34.9991Z",
    stroke: "#719A5D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0007 15H100.001C101.327 15 102.598 15.5267 103.536 16.4642C104.473 17.4018 105 18.6733 105 19.9992V100.001C105 101.327 104.473 102.598 103.536 103.536C102.598 104.473 101.327 105 100.001 105H40.0007C39.344 105 38.6937 104.871 38.0869 104.62C37.4801 104.369 36.9287 104.001 36.4642 103.537C35.9998 103.072 35.6313 102.521 35.3799 101.914C35.1285 101.308 34.9991 100.658 34.9991 100.001V85.0008",
    stroke: "#0D5F4F",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcfStep4);
export default __webpack_public_path__ + "static/media/PCFStep4.ffa3ccc93bab7948fcf8689b7709d596.svg";
export { ForwardRef as ReactComponent };